class CompareAndUpdateCandidateDetailsController {
    constructor() { }
    $onInit() {
        this._setFields();
    }
    _setFields() {
        angular.forEach(this.candidateConflictDetails.candidateConflictDetails, (conflict, key) => {
            conflict.fieldId = conflict.fieldName.split(" ").join("-");
            conflict.selectedValue = conflict.newValue;
            conflict.newValueSelected = true;
        });
    }
    updateField(index, flag) {
        if (flag) {
            this.candidateConflictDetails.candidateConflictDetails[index].selectedValue = this.candidateConflictDetails.candidateConflictDetails[index].newValue;
        }
        else {
            this.candidateConflictDetails.candidateConflictDetails[index].selectedValue = this.candidateConflictDetails.candidateConflictDetails[index].oldValue;
        }
    }
    save() {
        let contactDetails = {
            firstName: this.candidateConflictDetails.candidateConflictDetails[0].selectedValue,
            lastName: this.candidateConflictDetails.candidateConflictDetails[1].selectedValue,
            email: this.candidateConflictDetails.candidateConflictDetails[2].selectedValue,
            phoneNumber: this.candidateConflictDetails.candidateConflictDetails[3].selectedValue
        };
        this.saveCallback({ contactDetails: contactDetails });
    }
    cancel() {
        if (this.candidateConflictDetails && this.candidateConflictDetails.candidateConflictDetails.length > 0) {
            let contactDetails = {
                firstName: this.candidateConflictDetails.candidateConflictDetails[0].selectedValue,
                lastName: this.candidateConflictDetails.candidateConflictDetails[1].selectedValue,
                email: this.candidateConflictDetails.candidateConflictDetails[2].selectedValue,
                phoneNumber: this.candidateConflictDetails.candidateConflictDetails[3].selectedValue
            };
            this.cancelCallback({ contactDetails: contactDetails });
        }
        else {
            this.cancelCallback(null);
        }
    }
}
// import * as TEMPLATE from './compare-and-update-candidate-details.html';
import * as TEMPLATE from 'raw-loader!./compare-and-update-candidate-details.html';
export const CompareAndUpdateCandidateDetailsComponent = {
    selector: 'compareAndUpdateCandidateDetails',
    component: {
        bindings: {
            candidateConflictDetails: '=',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: CompareAndUpdateCandidateDetailsController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addCandidates/addCandidates/uploadResumes/compareAndUpdateCandidateDetails/compare-and-update-candidate-details.html'
    }
};
//# sourceMappingURL=compare-and-update-candidate-details.component.js.map